import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.picker = flatpickr(this.element, {
      inline: true,
      onChange: this.handleOnChange.bind(this),
      dateFormat: "Ymd"
    })

    this.handleCalendarClick = this.stopDropdownClose.bind(this)
    this.picker.calendarContainer.addEventListener('click', this.handleCalendarClick)
  }

  stopDropdownClose(e) {
    e.stopPropagation()
  }

  handleOnChange(selectedDates, dateStr, instance) {
    if (!this.hasUrlValue) { alert('Bad Setup')}
    if (selectedDates.length === 0) { alert('No dates') }

    const url = this.urlValue.replace(/19000101/g, dateStr)

    if (window.Turbo) {
      Turbo.visit(url)
    } else {
      window.location.href = url
    }
  }

  disconnect() {
    if (this.picker) {
      this.picker.calendarContainer.removeEventListener('click', this.handleCalendarClick)
      this.picker.destroy()
      this.picker = null
    }
  }
}
